export default {
  state: {
    title: '',
    url: '',
    engTitle: '',
    engURL: ''
  },
  getters: {
    title: state => state.title,
    url: state => state.url,
    engTitle: state => state.engTitle,
    engURL: state => state.engURL,
    form: state => state
  },
  actions: {
  },
  mutations: {
    change (state, data) {
      this.state.languages.state = JSON.parse(JSON.stringify(data))
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/languages.js